import { FormikProps } from 'formik';
import { Form } from '~/src/components/language';

export enum FormName {
  FIRST_NAME = 'first-name',
  LAST_NAME = 'last-name',
  EMAIL = 'email',
  PHONE = 'phone',
  COMPANY = 'company',
  MAU = 'mau',
  COUNTRY = 'country',
  MESSAGE = 'message',
  ACCEPT_PRIVACY_POLICY = 'privacy-policy',
  ACCEPT_EDUCATION_CONTENT = 'education-content',
  RECAPTCHA_RESPONSE = 'recaptchaResponse',
}

export type FormValues = {
  [FormName.FIRST_NAME]: string;
  [FormName.LAST_NAME]: string;
  [FormName.EMAIL]: string;
  [FormName.PHONE]: string;
  [FormName.COMPANY]: string;
  [FormName.MAU]: string;
  [FormName.COUNTRY]: string;
  [FormName.MESSAGE]: string;
  [FormName.ACCEPT_PRIVACY_POLICY]: boolean;
  [FormName.ACCEPT_EDUCATION_CONTENT]: boolean;
  [FormName.RECAPTCHA_RESPONSE]: string;
};

export type FormProps = Omit<JSX.IntrinsicElements['div'], 'ref'> & {
  readonly form: FormikProps<FormValues>;
  readonly source: string;
  readonly formFields: Form;
  readonly hidePhone: boolean;
};
